<template>
  <v-dialog
    v-model="visibility"
    max-width="600"
    persistent
  >
    <v-card>
      <v-alert
        v-model="error"
        dismissible
        type="error"
      >
        {{errorMsg}}
      </v-alert>

      <div class="px-0">

        <v-card-title class="headline pl-4 py-2 pr-2">
          Zarządzaj dostępem
          <v-spacer></v-spacer>
          <v-btn
            @click.native="visibility = false"
            icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>
        <div v-if="!dialogBusy">
          <div class="scrollable-height">
            <div class="py-4">
              <div class="px-4">
                <div class="body-2 grey--text">
                  Wybierz osoby którym chcesz nadać dostęp do elementu:
                </div>
              </div>

              <div class="px-4">
                <v-autocomplete
                  v-model="usersAccess"
                  :items="users"
                  item-text="value"
                  item-value="id"
                  multiple
                  label="Wybierz osobę"
                >
                </v-autocomplete>
              </div>

              <div v-if="usersAccessList.length > 0">
                <div class="px-4">
                  <div class="body-2 grey--text">
                    Osoby które mają dostęp do elementu:
                  </div>
                </div>
                <div class="px-4">
                  <v-chip
                    class="ml-0 mr-3"
                    v-for="(user) in usersAccessList"
                    :key="user.id"
                    close
                    @input="removeUser(user.id)"
                  >{{user.name}}</v-chip>
                </div>
              </div>
            </div>
          </div>
          <v-divider></v-divider>
          <v-card-actions class="px-4 py-4">
            <v-spacer></v-spacer>

            <v-btn
              color="primary lighten-2"
              flat="flat"
              @click="setVisbility"
            >
              Anuluj
            </v-btn>

            <v-btn
              color="primary"
              :loading="busy"
              :disabled="busy"
              @click="updateAccessData"
            >
              Zapisz
            </v-btn>
          </v-card-actions>
        </div>
        <div v-if="dialogBusy">
          <div class="py-4 text-xs-center">
            <v-progress-circular
              :size="30"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { getError } from '../../../helpers/helpers';
import { accessManage } from '../../../repository/files';

export default {
  name: 'permissions-dialog',
  data: () => ({
    busy: false,
    errorMsg: null,
    error: null,
    dialogBusy: false,
    users: [],
    usersAccess: [],
  }),
  computed: {
    ...mapGetters('files', [
      'dialogVisibility',
    ]),
    visibility: {
      get() {
        return this.dialogVisibility.type === 'permissions';
      },
      set(val) {
        this.setDialogVisbility(val);
      },
    },
    usersAccessList() {
      const list = [];
      this.usersAccess.forEach((id) => {
        const currentUser = this.users.find(user => user.id === id);
        const item = {
          id,
          name: currentUser.value,
        };
        list.push(item);
      });
      return list;
    },
  },
  methods: {
    ...mapActions('files', [
      'setDialogVisbility',
      'saveAccesses',
    ]),
    setVisbility() {
      this.setDialogVisbility(false);
    },
    getError(errorData) {
      this.dialogBusy = false;
      this.busy = false;
      this.errorMsg = getError(errorData);
      this.error = true;
    },
    removeUser(id) {
      const index = this.usersAccess.indexOf(id);
      if (index > -1) {
        this.usersAccess.splice(index, 1);
      }
    },
    async getAccessData() {
      this.dialogBusy = true;
      try {
        let formRes = await accessManage(this.dialogVisibility.data);
        formRes = formRes.data.data;
        this.users = formRes.users;
        this.usersAccess = formRes.users_with_access;
        this.dialogBusy = false;
      } catch (e) {
        this.getError(e);
      }
    },
    async updateAccessData() {
      this.busy = true;
      try {
        const accessData = {
          items_id: this.dialogVisibility.data.items_id,
          users_id: this.usersAccess,
        };
        await this.saveAccesses(accessData);
        this.busy = false;
      } catch (e) {
        this.getError(e);
      }
    },
  },
  watch: {
    visibility(val) {
      if (val === true) {
        this.getAccessData();
        this.errorMsg = null;
        this.error = null;
      }
    },
  },
};
</script>
